import { render, staticRenderFns } from "./people_three.vue?vue&type=template&id=19056cfc&scoped=true&"
import script from "./people_three.vue?vue&type=script&lang=js&"
export * from "./people_three.vue?vue&type=script&lang=js&"
import style0 from "./people_three.vue?vue&type=style&index=0&id=19056cfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19056cfc",
  null
  
)

component.options.__file = "people_three.vue"
export default component.exports